import { ReactElement } from 'react';
import { Col } from 'react-bootstrap';
import { getAnswersAction } from '../../actions/getAnswersAction';
import { getQuestionSetAction } from '../../actions/getQuestionSetAction';
import { HpClaimsClientConfiguration } from '../../config/configurationTypes';
import { mapDispatchToPropsDefault } from '../../engineClient/components/questionSetForm/questionSetPageFunctions';
import {
  HpCreateQuestionSetPageProps,
  HpMapStateToPropsFunc,
  HpQuestionSetPageMapDispatchToPropsFunc,
  HpRenderSideBarProps,
  HpSideBarRendererFunc
} from '../../engineClient/components/questionSetForm/questionSetPageTypes';
import { registerConfigurationAction } from '../../engineClient/config/registerClientConfig';
import { HpQuestionSetPageDispatchProps } from '../../engineClient/types/questionSetPagePropTypes';
import { HpClaimsMetaData, HpGlobalState } from '../../types/stateTypes';
import { SideBar } from '../sideBar';
import { LoadingWidget } from '../widgets/loadingWidget';
import { HpClaimsQuestionSetPageStateProps } from './questionSetPageTypes';

let hpPhoneNumber: string;

registerConfigurationAction((config) => {
  ({ hpPhoneNumber } = config as HpClaimsClientConfiguration);
});

const createSideBar: HpSideBarRendererFunc = ({
  isDesktop,
  metaData,
  answers,
  activeSectionId
}: HpRenderSideBarProps): ReactElement => {
  // ensureDefined(metaData, 'metaData');

  return (
    SideBar && (
      <Col xs={isDesktop ? 4 : 12}>
        <SideBar
          hpPhoneNumber={hpPhoneNumber}
          metaData={metaData as HpClaimsMetaData}
          answers={answers}
          activeSectionId={activeSectionId}
        />
      </Col>
    )
  );
};

const mapDispatchToProps: HpQuestionSetPageMapDispatchToPropsFunc = (dispatch) => {
  const props: HpQuestionSetPageDispatchProps = {
    ...mapDispatchToPropsDefault(dispatch),
    getQuestionSet: (payload) => dispatch(getQuestionSetAction(payload)),
    getAnswers: (payload) => dispatch(getAnswersAction(payload))
  };

  return props;
};

const mapStateToProps: HpMapStateToPropsFunc = (engineState) => {
  const { questionSet, userInterface, policies, claimEnquiryResult, user } = engineState as HpGlobalState;
  const state: HpClaimsQuestionSetPageStateProps = {
    ...questionSet,
    policies,
    userInterface,
    user,
    ...claimEnquiryResult
  };

  return state;
};

export const questionSetPageProps: HpCreateQuestionSetPageProps = {
  createHiddenFormFields: null,
  createSideBar,
  mapStateToProps,
  mapDispatchToProps,
  LoadingWidget
};
